import {CatalogImportError} from "../interfaces/ImportInterface";

const parseCsvErrorMessages = (errorMessages: string[]): Record<number, string[]> => {
  return errorMessages.reduce((acc: Record<number, string[]>, message: string) => {
    const [index, error] = message.split(":")
    if (index && error) {
      acc[index] = error.split(",")
    }
    return acc
  }, {} as Record<number, string[]>)
}

const getClassNameByErrorType = (errorMessages: string[], errorType: CatalogImportError): string => {
  return errorMessages && errorMessages.includes(errorType) ? "color-danger fw-bold" : "";
};

export const importUtils = Object.freeze({
  parseCsvErrorMessages,
  getClassNameByErrorType
});
